// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__3ruxM","noRide":"style_noRide__2UZqd","noRide_info":"style_noRide_info__zRJYd"};